import React from 'react';
import moment from 'moment';

import {OffsetDateTime} from "../services/CommonModel";

type DateRangeDescriptionProps = {
    from?: OffsetDateTime | null,
    to?: OffsetDateTime | null
}

const DateRangeDescription = ({from, to} : DateRangeDescriptionProps) => {

    if (from == null || to == null) {
        // There should never be a case where one timestamp is set and the other is null
        // They are either both null (e.g. pickup date) or both set (e.g. delivery date)
        return null;
    }

    const mFrom = moment(from);
    const mTo = moment(to);
    if (mFrom.isSame(mTo, 'day')) {
        const fromTime = mFrom.format('HH:mm');
        if (fromTime === mTo.format('HH:mm')) {
            if (fromTime === "00:00") {
                return (
                    <>{mFrom.format("DD/MM/YYYY")}</>
                );
            } else {
                return (
                    <>{mFrom.format("DD/MM/YYYY")}<br />{fromTime}</>
                );
            }
        }
        return (
            <>{mFrom.format("DD/MM/YYYY")}<br />{fromTime} - {mTo.format("HH:mm")}</>
        );
    }
    return (
        <>{mFrom.format("DD/MM/YYYY HH:mm")}<br />{mTo.format("DD/MM/YYYY HH:mm")}</>
    );
};

export default DateRangeDescription;